import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '@serengeti/serengeti-common';
import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';
import {NotificationService} from '@serengeti/serengeti-notification';
// import { AuthService, SocialUser } from 'angularx-social-login';

@DashboardWidgetLookup('WizardMarketSearchComponent')
@Component({
  selector: 'app-wizard-market-search',
  templateUrl: './wizard-market-search.component.html',
  styleUrls: ['./wizard-market-search.component.scss']
})
export class WizardMarketSearchComponent implements OnInit, DashboardWidgetContent {

  marketSearchName: string;

	private googleLogin: boolean;
	apiOauthState: boolean;
  isKeycloakUsed: boolean;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private notificationService: NotificationService
		// private authService: AuthService
  ) {
		// if (this.apiOauthState) {
		// 	this.authService.authState.subscribe((user) => {
		// 		this.googleLogin = (user != null);
		// 	});
		// }
  }

  property(): boolean {
    return false;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
    this.isKeycloakUsed = localStorage.getItem('isKeycloakUsed') === 'true';

  }

  public onSubmit(values:any):boolean {
    this.translateService.get([
      'dashboard.items.market-search.alert.no-search-name'
    ]).subscribe((messages: any) => {
      if (this.marketSearchName && this.marketSearchName.trim() !== '') {
        this.router.navigate(['/main', { outlets: { content: 'market/product/search' }}], { queryParams: { search : this.marketSearchName }});
      } else {
        alert(messages['dashboard.items.market-search.alert.no-search-name']);
      }
    });
    return false;
  }

  goLogin() {
    this.router.navigate(['/signin']);
  }

  goConsole() {
    this.router.navigate(['/main']);
  }

  doLogout() {
    this.router.navigate(['/member/logout']);
  }

}
